// Import vue components
import Vue from "vue";

// layouts
import SidebarLayout from "./SidebarLayout.vue";
Vue.component("sidebar-layout", SidebarLayout);

// sign in form
import AgreementArticles from "./AgreementArticles.vue";
import ApplicationComments from "./ApplicationComments.vue";
import ClosedNotice from "./ClosedNotice.vue";
import SignInForm from "./SignInForm.vue";
Vue.component("sign-in-form", SignInForm);

Vue.component("application-comments", ApplicationComments);
Vue.component("agreement-articles", AgreementArticles);
Vue.component("closed-notice", ClosedNotice);

// application
import ApplicationReadOnly from "./ApplicationReadOnly.vue";
import ApplicationReadOnly2022 from "./ApplicationReadOnly2022.vue";
import ApplicationStep1 from "./ApplicationSteps/Step1.vue";
import ApplicationStep2 from "./ApplicationSteps/Step2.vue";
import ApplicationStep3 from "./ApplicationSteps/Step3.vue";
import ApplicationStep4 from "./ApplicationSteps/Step4.vue";
import ApplicationStep5 from "./ApplicationSteps/Step5.vue";
import ApplicationStep6 from "./ApplicationSteps/Step6.vue";
import ApplicationStep7 from "./ApplicationSteps/Step7.vue";

Vue.component("application-step1", ApplicationStep1);
Vue.component("application-step2", ApplicationStep2);
Vue.component("application-step3", ApplicationStep3);
Vue.component("application-step4", ApplicationStep4);
Vue.component("application-step5", ApplicationStep5);
Vue.component("application-step6", ApplicationStep6);
Vue.component("application-step7", ApplicationStep7);
Vue.component("application-read-only", ApplicationReadOnly);
Vue.component("application-read-only-2022", ApplicationReadOnly2022);

// non profit application steps
import NpApplicationStep1 from "./NpApplicationSteps/Step1.vue";
import NpApplicationStep2 from "./NpApplicationSteps/Step2.vue";
import NpApplicationStep3 from "./NpApplicationSteps/Step3.vue";
import NpApplicationStep4 from "./NpApplicationSteps/Step4.vue";
import NpApplicationStep5 from "./NpApplicationSteps/Step5.vue";
import NpApplicationStep6 from "./NpApplicationSteps/Step6.vue";
import NpApplicationStep7 from "./NpApplicationSteps/Step7.vue";

Vue.component("np-application-step1", NpApplicationStep1);
Vue.component("np-application-step2", NpApplicationStep2);
Vue.component("np-application-step3", NpApplicationStep3);
Vue.component("np-application-step4", NpApplicationStep4);
Vue.component("np-application-step5", NpApplicationStep5);
Vue.component("np-application-step6", NpApplicationStep6);
Vue.component("np-application-step7", NpApplicationStep7);

// form input components
import BooleanField from "./FormInputs/BooleanField.vue";
import DateField from "./FormInputs/DateField.vue";
import EmailField from "./FormInputs/EmailField.vue";
import FileField from "./FormInputs/FileField.vue";
import LongTextField from "./FormInputs/LongTextField.vue";
import NumberField from "./FormInputs/NumberField.vue";
import PhoneField from "./FormInputs/PhoneField.vue";
import RadioField from "./FormInputs/RadioField.vue";
import SelectField from "./FormInputs/SelectField.vue";
import StringField from "./FormInputs/StringField.vue";
import YesNoField from "./FormInputs/YesNoField.vue";
Vue.component("boolean-field", BooleanField);
Vue.component("yes-no-field", YesNoField);
Vue.component("date-field", DateField);
Vue.component("email-field", EmailField);
Vue.component("file-field", FileField);
Vue.component("long-text-field", LongTextField);
Vue.component("number-field", NumberField);
Vue.component("phone-field", PhoneField);
Vue.component("select-field", SelectField);
Vue.component("string-field", StringField);
Vue.component("radio-field", RadioField);
